document.addEventListener("DOMContentLoaded", () => {
  console.log("Island Daze Theme Loaded");

  // Sticky Header
  const header = document.querySelector(".header-section");
  if (header) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    });
  }

  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu-drawer");
  const closeMenu = document.querySelector(".close-menu");

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener("click", () => {
      mobileMenu.classList.add("active");
      document.body.style.overflow = "hidden";
    });

    closeMenu.addEventListener("click", () => {
      mobileMenu.classList.remove("active");
      document.body.style.overflow = "";
    });

    // Mobile Menu Accordion
    const mobileDropdowns = document.querySelectorAll('.mobile-dropdown-trigger');
    mobileDropdowns.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = trigger.parentElement;
        parent.classList.toggle('active');
        
        // Optional: Close other open menus
        // mobileDropdowns.forEach(other => {
        //   if(other !== trigger) other.parentElement.classList.remove('active');
        // })
      });
    });
  }

  // Initialize Splide Sliders
  const sliders = document.querySelectorAll(".splide");
  if (sliders.length && typeof Splide !== "undefined") {
    sliders.forEach((slider) => {
      new Splide(slider).mount();
    });
  }
  // Global Scroll Animations
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target); // Run once
      }
    });
  }, observerOptions);

  // auto-assign animation class to sections and key elements
  // Exclude header closely to avoid sticky/dropdown issues
  const animatedElements = document.querySelectorAll('.shopify-section:not(#shopify-section-header), .footer-section, .main-product, .collection-hero, .article-template, h1, h2, .btn, .card');
  
  animatedElements.forEach(el => {
    // Double check to ensure we don't animate the header wrapper which can break sticky/mega menu positioning
    // Also exclude sections with drawers (Filter Drawer) as transform breaks fixed positioning
    if (!el.querySelector('header.header-wrapper') && !el.querySelector('.cg-drawer')) {
      el.classList.add('animate-on-scroll');
      observer.observe(el);
    }
  });

  // iOS Video Autoplay Fix
  const bgVideos = document.querySelectorAll('video[autoplay]');
  bgVideos.forEach(video => {
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.playsInline = true;
    
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Autoplay blocked (e.g. Low Power Mode on iOS). Play on first user interaction.
        const startVideo = () => {
          video.play();
        };
        document.addEventListener('touchstart', startVideo, { once: true });
        document.addEventListener('click', startVideo, { once: true });
      });
    }
  });
});
